import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import { SearchReservaTgModel } from '../../../models/reserva-compras.model'

@Injectable({
  providedIn: 'root',
})
export class AgendaReservaService {
  private baseUrl = environment.baseUrl
  private resource = 'AgendaReserva'

  constructor(private httpClient: HttpClient) {}

  public listPagedTg(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/tg/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedTg(
    page: number,
    rows = 15,
    model: SearchReservaTgModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/tg/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public getOsByTg(propostaId: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/tg/${propostaId}/os`,
    )
  }
}
